import React, {Fragment} from 'react';
import {MODAL_WIDTH_LG, MODAL_WIDTH_SM} from '../../styles/constants';
import Call from '../../hocs/call';
import {translate} from 'react-i18next';
import {
  changeDefaultCategorySchemeSelectorCreate,
  hideDefaultCategorySchemeSelector,
  readDefaultCategorySchemeSelectorCategorySchemes,
  showDefaultCategorySchemeSelectorCreateModal,
  showDefaultCategorySchemeSelectorSelectModal,
  submitDefaultCategorySchemeSelectorCreate,
  submitDefaultCategorySchemeSelectorSelect
} from './actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import EnhancedModal from '../../components/enhanced-modal';
import {Button, Icon, Modal} from "antd";
import ArtefactList from "../../components/artefact-list";
import ReduxCategorySchemeDetailModal
  from "../../redux-components/redux-category-scheme-detail-modal";
import {DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX} from "./reducer";
import {reuseAction} from "../../utils/reduxReuse";
import {showCategorySchemeDetail} from "../../redux-components/redux-category-scheme-detail-modal/actions";
import CategoryForm from "./CategoryForm";
import {isDictionaryValid} from "../../utils/artefactValidators";

const mapStateToProps = state => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  isVisible: state.middlewares.defaultCategorySchemeSelector.isVisible,
  isSelectModalVisible: state.middlewares.defaultCategorySchemeSelector.isSelectModalVisible,
  isCreateModalVisible: state.middlewares.defaultCategorySchemeSelector.isCreateModalVisible,
  categorySchemes: state.middlewares.defaultCategorySchemeSelector.categorySchemes,
  categorySchemeDetail: state.middlewares.defaultCategorySchemeSelector.categorySchemeDetail,
  category: state.middlewares.defaultCategorySchemeSelector.category
});

const mapDispatchToProps = dispatch => ({
  onSelectModalShow: () => dispatch(showDefaultCategorySchemeSelectorSelectModal()),
  onCreateModalShow: () => dispatch(showDefaultCategorySchemeSelectorCreateModal()),
  fetchCategorySchemes: () =>
    dispatch(readDefaultCategorySchemeSelectorCategorySchemes()),
  onHide: () => dispatch(hideDefaultCategorySchemeSelector()),
  onCategorySchemeShow: (categorySchemeTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(showCategorySchemeDetail(categorySchemeTriplet, defaultItemsViewMode), DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX)),
  onSelectSubmit: categorySchemeTriplet =>
    dispatch(submitDefaultCategorySchemeSelectorSelect(categorySchemeTriplet)),
  onCreateSubmit: category => dispatch(submitDefaultCategorySchemeSelectorCreate(category)),
  onCategoryChange: fields => dispatch(changeDefaultCategorySchemeSelectorCreate(fields))
});

export const DefaultCategorySchemeSelector = ({
                                                t,
                                                nodes,
                                                nodeId,
                                                isVisible,
                                                isSelectModalVisible,
                                                isCreateModalVisible,
                                                categorySchemes,
                                                categorySchemeDetail,
                                                fetchCategorySchemes,
                                                category,
                                                onCategoryChange,
                                                onHide,
                                                onCategorySchemeShow,
                                                onSelectModalShow,
                                                onCreateModalShow,
                                                onSelectSubmit,
                                                onCreateSubmit
                                              }) => {

  const connectedNode = nodes.find(node => node.general.id === nodeId);
  const defaultItemsViewMode = connectedNode
    ? connectedNode.general.defaultItemsViewMode
    : null;

  return defaultItemsViewMode
    ? (
      <Fragment>
        <Call
          cb={
            () => {
              onHide();
              Modal.destroyAll();
              Modal.confirm({
                icon: <Icon type="warning"/>,
                title: t('middlewares.defaultCategorySchemeSelector.alert.title'),
                content:
                  <span
                    onClick={() => {
                      Modal.destroyAll();
                    }}
                    style={{textDecoration: "underline", color: "red", cursor: "pointer"}}
                  >
                    {t('middlewares.defaultCategorySchemeSelector.alert.backToHome')}
                  </span>,
                okText: t('middlewares.defaultCategorySchemeSelector.alert.selectButton.title'),
                cancelText: t('middlewares.defaultCategorySchemeSelector.alert.createButton.title'),
                onOk: () => {
                  onSelectModalShow();
                },
                onCancel: () => {
                  onCreateModalShow();
                }
              });
            }
          }
          cbParam={isVisible}
          disabled={!isVisible}
        >
          <span></span>
        </Call>
        <EnhancedModal
          visible={isSelectModalVisible}
          title={t('middlewares.defaultCategorySchemeSelector.selectModal.title')}
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>}
          onCancel={onHide}
          withDataLanguageSelector
        >
          <Call cb={fetchCategorySchemes}>
            <ArtefactList
              artefacts={categorySchemes}
              onDetailShow={triplet => onCategorySchemeShow(triplet, defaultItemsViewMode)}
              onRowClick={({id, agencyID, version}) => onSelectSubmit({id, agencyID, version})}
            />
          </Call>
        </EnhancedModal>
        <ReduxCategorySchemeDetailModal
          instancePrefix={DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX}
          instanceState={categorySchemeDetail}
        />
        <EnhancedModal
          visible={isCreateModalVisible}
          title={t('middlewares.defaultCategorySchemeSelector.createModal.title')}
          width={MODAL_WIDTH_SM}
          footer={
            <div>
              <Button onClick={onHide}>
                {t('commons.buttons.close.title')}
              </Button>
              <Button
                onClick={() => onCreateSubmit(category)}
                type="primary"
                disabled={
                  category === null ||
                  category.catCode === null ||
                  !isDictionaryValid(category.labels)
                }
              >
                {t('commons.buttons.save.title')}
              </Button>
            </div>
          }
          onCancel={onHide}
        >
          <CategoryForm
            category={category}
            onChange={onCategoryChange}
          />
        </EnhancedModal>
      </Fragment>
    )
    : <span/>
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DefaultCategorySchemeSelector);



// WEBPACK FOOTER //
// ./src/middlewares/default-category-scheme-selector/index.jsx